var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blog-page" }, [
    _c(
      "div",
      { staticClass: "container py-4 blog-container" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { staticClass: "mb-3 mb-lg-0", attrs: { cols: "12", lg: "8" } },
              [
                _vm.isProcessing
                  ? _c(
                      "div",
                      { staticClass: "card-shell p-3" },
                      [
                        _c(
                          "ContentLoader",
                          { attrs: { width: "100%", height: "420" } },
                          [
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "0",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "56"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "70",
                                rx: "10",
                                ry: "10",
                                width: "60%",
                                height: "22"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "108",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "230"
                              }
                            }),
                            _vm._v(" "),
                            _c("rect", {
                              attrs: {
                                x: "0",
                                y: "354",
                                rx: "10",
                                ry: "10",
                                width: "100%",
                                height: "54"
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm.postNotFound
                  ? _c("div", { staticClass: "card-shell p-4 empty-state" }, [
                      _c("h1", { staticClass: "blog-title mb-2" }, [
                        _vm._v("Artikel tidak ditemukan")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm._v(
                          "Artikel mungkin sudah dihapus atau URL tidak valid."
                        )
                      ])
                    ])
                  : _vm.post
                  ? _c("article", { staticClass: "card-shell article-shell" }, [
                      _c("h1", { staticClass: "blog-title" }, [
                        _vm._v(_vm._s(_vm.post.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "article-meta mt-2 mb-3" }, [
                        _vm.post.date
                          ? _c(
                              "span",
                              { staticClass: "meta-pill" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: "calendar-alt",
                                    "aria-hidden": "true"
                                  }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.post.date) +
                                    "\n                        "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.post.views
                          ? _c(
                              "span",
                              { staticClass: "meta-pill" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "eye", "aria-hidden": "true" }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.post.views) +
                                    " dilihat\n                        "
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.post.category && _vm.post.category.length
                        ? _c(
                            "div",
                            { staticClass: "meta-tags mb-3" },
                            _vm._l(_vm.post.category, function(
                              category,
                              index
                            ) {
                              return _c(
                                "b-link",
                                {
                                  key: category.id,
                                  staticClass: "tag-chip",
                                  on: {
                                    click: function($event) {
                                      return _vm.gotoCategory(category.title)
                                    }
                                  }
                                },
                                [
                                  index === 0
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          icon: "tag",
                                          "aria-hidden": "true"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(category.title) +
                                      "\n                        "
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.convertUrl
                        ? _c(
                            "div",
                            { staticClass: "video-wrap mb-3" },
                            [
                              _c("b-embed", {
                                attrs: {
                                  type: "iframe",
                                  aspect: "16by9",
                                  src: _vm.convertUrl,
                                  allowfullscreen: "",
                                  title: "Video tutorial: " + _vm.post.title
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "article-content",
                        attrs: {
                          "aria-label": "Konten artikel: " + _vm.post.title
                        },
                        domProps: { innerHTML: _vm._s(_vm.post.description) }
                      }),
                      _vm._v(" "),
                      _vm.blogAdHtml
                        ? _c("div", {
                            staticClass: "ad-wrap mt-4",
                            domProps: { innerHTML: _vm._s(_vm.blogAdHtml) }
                          })
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("b-col", { attrs: { cols: "12", lg: "4" } }, [
              _c(
                "div",
                { staticClass: "sidebar-block card-shell mb-3" },
                [
                  _c("h6", { staticClass: "sidebar-title" }, [
                    _vm._v("Cari Artikel")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.goToSearch($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "input-group input-full-width" },
                        [
                          _c("b-input", {
                            attrs: {
                              type: "text",
                              placeholder: "Cari topik blog",
                              "aria-label": "Cari artikel"
                            },
                            model: {
                              value: _vm.searchQuery,
                              callback: function($$v) {
                                _vm.searchQuery = $$v
                              },
                              expression: "searchQuery"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group-append" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "search-btn",
                                  attrs: {
                                    type: "submit",
                                    variant: "primary",
                                    "aria-label": "Cari artikel"
                                  }
                                },
                                [_vm._v("Cari")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-block card-shell mb-3" }, [
                _c("h6", { staticClass: "sidebar-title" }, [
                  _vm._v("Kategori")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-wrap" },
                  [
                    _c(
                      "b-link",
                      {
                        staticClass: "category-chip all-chip",
                        attrs: { to: { name: "version2-blog-list" } }
                      },
                      [
                        _vm._v(
                          "\n                            Semua\n                        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.category_list, function(category, index) {
                      return _c(
                        "b-link",
                        {
                          key: index,
                          staticClass: "category-chip",
                          on: {
                            click: function($event) {
                              return _vm.gotoCategory(category.text)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(category.text) +
                              "\n                        "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.latestPostList.length > 0
                ? _c("div", { staticClass: "sidebar-block card-shell" }, [
                    _c("h6", { staticClass: "sidebar-title" }, [
                      _vm._v("Artikel Terbaru")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "latest-list" },
                      _vm._l(_vm.latestPostList, function(post, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "latest-item",
                            class: {
                              "latest-item-border":
                                _vm.latestPostList.length - 1 !== index
                            }
                          },
                          [
                            _c(
                              "b-link",
                              {
                                staticClass: "latest-link text-ip",
                                on: {
                                  click: function($event) {
                                    return _vm.goto(post)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(post.title) +
                                    "\n                            "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }